// @ts-expect-error JS file
import UIAvatar from 'ui-addon-avatars/UIAvatar';
import { getProperty, toString, getId } from 'customer-data-objects/model/ImmutableModel';
// @ts-expect-error JS file
import AssociationsStore from 'crm_data/associations/AssociationsStore';
// @ts-expect-error JS file
import CompaniesStore from 'crm_data/companies/CompaniesStore';
// @ts-expect-error JS file
import { CONTACT_TO_COMPANY } from 'crm_data/associations/AssociationTypes';
// @ts-expect-error JS file
import { useStoreDependency } from 'general-store';
import FormattedMessage from 'I18n/components/FormattedMessage';
import SubjectDependency from '../../../../flux/dependencies/SubjectDependency';
import FormattedName from 'I18n/components/FormattedName';
import EMPTY_LABEL from '../../../../constants/EmptyLabel';
import { View } from 'foundations-components/components/View';
import { Media } from 'foundations-components/transitional/components/Media';
import { MediaLeft } from 'foundations-components/transitional/components/MediaLeft';
import { MediaBody } from 'foundations-components/transitional/components/MediaBody';
import { Text } from 'foundations-components/components/Text';
import { useMemo, useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const companyDependency = {
  stores: [AssociationsStore, CompaniesStore],
  deref: ({
    objectType,
    subjectId
  }) => {
    const associations = AssociationsStore.get({
      objectType,
      objectId: subjectId,
      associationType: CONTACT_TO_COMPANY
    });
    if (!associations) {
      return null;
    }
    const possibleCompany = associations.get('results').first();
    if (!possibleCompany) {
      return null;
    }
    return CompaniesStore.get(possibleCompany);
  }
};
const MiniContactHighlight = ({
  objectType,
  subjectId
}) => {
  const subject = useStoreDependency(SubjectDependency, {
    objectType,
    subjectId
  });
  const company = useStoreDependency(companyDependency, {
    objectType,
    subjectId
  });
  const hasSubtitle = useMemo(() => {
    const jobTitle = getProperty(subject, 'jobtitle');
    return Boolean(jobTitle || company);
  }, [subject, company]);
  const renderTitle = useMemo(() => {
    const firstName = getProperty(subject, 'firstname');
    const lastName = getProperty(subject, 'lastname');
    const email = getProperty(subject, 'email');
    const hasLabel = firstName || lastName || email;
    return /*#__PURE__*/_jsx(Text, {
      as: "h2",
      typography: "heading-50",
      marginBlockEnd: "25",
      truncate: true,
      children: hasLabel ? /*#__PURE__*/_jsx(FormattedName, {
        givenName: firstName,
        familyName: lastName,
        email: email
      }) : EMPTY_LABEL
    });
  }, [subject]);
  const renderCompanyName = useCallback(jobTitle => {
    if (!company) {
      return null;
    }
    if (!jobTitle) {
      return toString(company);
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "contactHighlight.atCompany",
      options: {
        company: toString(company)
      }
    });
  }, [company]);
  const renderSubtitle = useMemo(() => {
    if (!hasSubtitle) {
      return null;
    }
    const jobTitle = getProperty(subject, 'jobtitle');
    return /*#__PURE__*/_jsxs(Text, {
      truncate: true,
      children: [/*#__PURE__*/_jsx(Text, {
        as: "span",
        marginInlineEnd: "100",
        children: jobTitle
      }), renderCompanyName(jobTitle)]
    });
  }, [subject, hasSubtitle, renderCompanyName]);
  return /*#__PURE__*/_jsx(View, {
    overflow: "hidden",
    "data-test-id": "mini-contact-highlight",
    children: /*#__PURE__*/_jsxs(Media, {
      align: "center",
      spacing: "extra-small",
      children: [/*#__PURE__*/_jsx(MediaLeft, {
        children: /*#__PURE__*/_jsx(UIAvatar, {
          email: getProperty(subject, 'email'),
          fileManagerKey: getProperty(subject, 'hs_avatar_filemanager_key'),
          size: "sm",
          vid: subject && getId(subject)
        })
      }), /*#__PURE__*/_jsxs(MediaBody, {
        marginBlockEnd: "-100",
        children: [renderTitle, renderSubtitle]
      })]
    })
  });
};
MiniContactHighlight.displayName = 'MiniContactHighlight';
export default MiniContactHighlight;